import { useQuery, useSubscription } from "@apollo/client";
import {
  MY_HR_COMPANIES_SUBSCRIPTION,
  MY_HR_GET_COMPANIES,
} from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";

const useOcCompanies = () => {
  const { data, loading, error, refetch } = useQuery(MY_HR_GET_COMPANIES, {
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
  });

  if (error) {
    console.log({
      component: "CompanyFilter",
      errorDescription:
        "Error occured when fetch data with MY_HR_GET_COMPANIES query",
      error: error,
    });
  }

  const { error: subscriptionError } = useSubscription(
    MY_HR_COMPANIES_SUBSCRIPTION,
    {
      onData: () => {
        refetch();
      },
    },
  );

  if (subscriptionError) {
    console.log({
      component: "CompanyFilter",
      errorDescription:
        "Error occured when subscribe data with COMPANIES_COMPANIES query",
      error: error,
    });
  }

  return { data, loading, error, companies: data?.companies?.rows || [] };
};

export default useOcCompanies;
